__webpack_require__.p = "https://enrolments.studyportals.eu/dist/";